{
  "level": "city1",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:city1",
    "objects": "AREAS.E3:city1.e3",
    "mesh": "TREES.E3:city1.e3"
  },
  "spawn_point": {
    "position": [
      0.0,
      0.0,
      0.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      0.0,
      100.0,
      0.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      0.0,
      0.0,
      0.0
    ],
    "bbox_max": [
      0.0,
      0.0,
      0.0
    ],
    "vertex_count": 0,
    "vertices": []
  },
  "sectors": [
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        265.5,
        372.5,
        110.0
      ],
      "bbox_max": [
        766.5,
        1434.5,
        205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        359.5,
        543.5,
        110.0
      ],
      "bbox_max": [
        766.5,
        1434.5,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        619.5,
        543.5,
        110.0
      ],
      "bbox_max": [
        744.5,
        668.5,
        112.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -112.0,
      "bbox_min": [
        739.5,
        663.5,
        112.0
      ],
      "bbox_max": [
        744.5,
        668.5,
        112.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -136.0,
      "bbox_min": [
        359.5,
        543.5,
        130.0
      ],
      "bbox_max": [
        740.0,
        1434.5,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -130.0,
      "bbox_min": [
        735.0,
        1417.5,
        130.0
      ],
      "bbox_max": [
        740.0,
        1422.5,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -150.0,
      "bbox_min": [
        359.5,
        543.5,
        150.0
      ],
      "bbox_max": [
        364.5,
        548.5,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -192.0,
      "bbox_min": [
        265.5,
        372.5,
        163.0
      ],
      "bbox_max": [
        519.5,
        1431.5,
        205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -175.0,
      "bbox_min": [
        304.5,
        480.5,
        163.0
      ],
      "bbox_max": [
        519.5,
        1431.5,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -163.0,
      "bbox_min": [
        514.5,
        1426.5,
        163.0
      ],
      "bbox_max": [
        519.5,
        1431.5,
        163.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        415.0,
        1372.5,
        190.0
      ],
      "bbox_max": [
        420.0,
        1377.5,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -205.0,
      "bbox_min": [
        265.5,
        372.5,
        205.0
      ],
      "bbox_max": [
        315.5,
        401.5,
        205.0
      ],
      "face_count": 3
    }
  ],
  "placed_objects": [
    {
      "tag": "C:\\editor\\simpleLW.lwo",
      "entity_class": "C:\\editor\\simpleLW.lwo",
      "piece_name": "",
      "offset": 54,
      "centroid": [
        -350.0,
        -50.0,
        -1300.0
      ],
      "bbox_min": [
        -500.0,
        -100.0,
        -1300.0
      ],
      "bbox_max": [
        -200.0,
        0.0,
        -1300.0
      ],
      "dimensions_source": {
        "span_x": 300.0,
        "span_y": 100.0,
        "height_z": 0.0,
        "door_width": 300.0,
        "door_depth": 100.0,
        "leaf_depth": 100.0,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          0.0,
          -1.0
        ]
      },
      "vertices": [
        [
          -500.0,
          -100.0,
          -1300.0
        ],
        [
          -200.0,
          0.0,
          -1300.0
        ],
        [
          -500.0,
          0.0,
          -1300.0
        ],
        [
          -200.0,
          -100.0,
          -1300.0
        ]
      ],
      "plane_distance": -1300.0
    }
  ],
  "tutorial_messages": []
}